import { render, staticRenderFns } from "./settlementBatchModify.vue?vue&type=template&id=5f079d4b&scoped=true"
import script from "./settlementBatchModify.vue?vue&type=script&lang=ts"
export * from "./settlementBatchModify.vue?vue&type=script&lang=ts"
import style0 from "./settlementBatchModify.vue?vue&type=style&index=0&id=5f079d4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f079d4b",
  null
  
)

export default component.exports